// src/lib/stripeLinks.js
// Helper utilities for Stripe dashboard URLs

/**
 * Returns the Stripe dashboard URL for a connected account.
 * Only works when you're logged into the platform account.
 */
export function stripeAccountDashboardUrl(accountId) {
  if (!accountId) return null;
  // Connect dashboard URL pattern
  return `https://dashboard.stripe.com/connect/accounts/${accountId}`;
}
